module.exports = __webpack_public_path__ + "static/media/greentick.6bf7a136.svg";